/*
 * @Author: Qzx
 * @Date: 2020-03-27 18:37:54
 * @Description: 多项目公用 main.js
 * @LastEditors: DouDou
 * @LastEditTime: 2020-09-30 11:28:46
 */
import Vue from 'vue'
// import XesLoggerSDK from '@xes/xes_fe_log'
import { XesChannel, XesShare, XesTalLogin, XesLoggerSDK } from '@xes/terra-utils'
import { Toast, Dialog, Lazyload, Popup } from 'vant'
import '@/common/less/base/reset.less'
import '@/common/less/base/common.less'
import '@/common/utils/xesDebug' // 移动端调试
import '@/common/utils/xesTalSdk' // 引入集团JSSDK文件

Vue.config.productionTip = false

// 热点投放
window._wltfChannel = new XesChannel()
window._xesShare = new XesShare()
Vue.prototype.$xesTalLogin = new XesTalLogin({
  env: window._wltfChannel.urlParams.env
})

Vue.use(Toast)
  .use(Dialog)
  .use(Lazyload)
  .use(Popup)

// vue新版日志
Vue.use(XesLoggerSDK, {
  logAppid: '1001132',
  common: {
    eventid: 'advance'
  },
  loadMsg: {
    open: false
  },
  hashchange: {
    open: false
  },
  appid: {
    'activity.xueersi.com': {
      appid: '1001132'
    },
    'huodong.xueersi.com': {
      appid: '1001961',
      appkey: '8a1fb3304fff3af30aa08b4bc3c3f1a1'
    },
    'm.xueersi.com': {
      appid: '1001977',
      appkey: 'e5dfbfaf4f65f27072224c0e34491f89'
    },
    'z.xueersi.com': {
      appid: '1002147',
      appkey: 'a6f7dc25365ba352413de883858c5136'
    }
  },
  param: {
    sourceid: window._wltfChannel.hotUrlParams.source || ''
  }
})
// click-log
Vue.prototype.$clog = function (clickid = 0, action = '', others = {}) {
  this.$xesLogger.clickMsg({ params: { clickid: `${100 + clickid}`, action, clicklevel: '1', ...others } })
}
